import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { DateTime } from 'luxon';
import type { graphql } from '@/gql/graphql';
import buildOptimisticMessageMentions, {
  OptimisticMessageMentionPersonFragment,
} from './buildOptimisticMessageMentions';

type MessageMentionInsert = ReturnType<
  typeof graphql.scalar<'message_mention_insert_input'>
>;

function isMessageMentionInsert(value: unknown): value is MessageMentionInsert {
  return typeof value === 'object' && value !== null;
}

export default function update_message_by_pk(
  args: {
    pk_columns: { id: string };
    _set?: ReturnType<typeof graphql.scalar<'message_set_input'>>;
  },
  cache: Pick<Cache, 'readFragment'>,
  info: Pick<ResolveInfo, 'variables'>,
) {
  if (args._set?.content === undefined) return null;

  const mentions = Array.isArray(info.variables.mentions)
    ? info.variables.mentions.filter(isMessageMentionInsert)
    : [];

  return {
    __typename: 'message',
    id: args.pk_columns.id,
    content: args._set?.content ?? null,
    content_template: args._set?.content_template ?? null,
    edited_at: DateTime.utc().toISO(),
    mentions: buildOptimisticMessageMentions(mentions, (personId) =>
      cache.readFragment(OptimisticMessageMentionPersonFragment, {
        __typename: 'person',
        id: personId,
      }),
    ),
  };
}
